export default __webpack_public_path__ + "9b37ad9a654f9348eaaaec44b9e801bd.svg";